define("shared/helpers/moment-format", ["exports", "@ember/component/helper", "@ember/utils", "moment"], function (_exports, _helper, _utils, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/utils",0,"moment"eaimeta@70e063a35619d71f

  class MomentFormat extends _helper.default {
    compute(_ref) {
      let [dateTime, format, timezone, secondaryFormat] = _ref;
      const newMoment = (0, _moment.default)(dateTime);

      if (!(0, _utils.isNone)(timezone)) {
        newMoment.tz(timezone);
      }

      if (secondaryFormat && (0, _moment.default)().isSame(newMoment, 'day')) {
        return newMoment.format(secondaryFormat);
      }

      return newMoment.format((0, _utils.isNone)(format) ? '' : format);
    }

  }

  _exports.default = MomentFormat;
});